
































import { Component, Vue } from "vue-property-decorator";
import AppHeader from "../../../views/AppHeader.vue";
import { ServiceArise, getUserAriseServices } from "../../../api/service-api";

@Component({
  components: {
    AppHeader
  }
})
export default class AccountingPage extends Vue {
  roles: ServiceArise[] = [];
  private async initServiceRoles() {
    this.roles = await getUserAriseServices();
  }

  get service() {
    return this.$store.state.service;
  }

  protected async created() {
    this.initServiceRoles();
  }
}
